<template>
  <div class="">
    <divider
      :height="diviserHeight1"
      :color="diviserColor1"
      class="mt-5"
      data-aos="fade-up"
      data-aos-duration="2000"
    />
    <div class="bloc md:flex mt-4">
      <div class="md:w-2/3">
        <div class="titre"  data-aos="fade-up"
             data-aos-duration="2000">
          {{ postes.title }}
        </div>
        <div class="detail"  data-aos="fade-up"
             data-aos-duration="2000">
          <span class="titre1">Lieu :</span>   {{ postes.place }}
        </div>
        <div class="detail"  data-aos="fade-up"
             data-aos-duration="2000">
          <span class="titre1">CDD :</span>   {{ postes.type }}
        </div>
        <div class="detail"  data-aos="fade-up"
             data-aos-duration="2000">
          <span class="titre1">Rénumération :</span>   {{ postes.paye }}
        </div>
      </div>

      <div class="md:w-1/3 md:flex justify-end md:mt-0 mt-6 md:pb-0 pb-3">
        <div
          class="button md:w-2/3 w-1/3"
          @click="selectPost"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Postuler
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/helper/divider'

export default {
  name: 'Index',
  components: {
    divider
  },
  props: {
    postes: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      diviserColor1: '#D3D9EB',
      diviserHeight1: '1px'
    }
  },
  created () {
  },
  methods: {
    selectPost () {
      this.$emit('oga', this.postes)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";
.titre{
  font-weight: normal;
  font-size: 24px;
  line-height: 160%;
  color: $black
}

.detail{
  font-weight: 400;
  font-size: 18px;
  line-height: 160%;
  color: #9395A2;
}
.titre1{
  font-weight: bold;
}
.button{
  background-color: $dev-green;
  height: 60px;
  border-radius: 0px;
  border: none;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 29px;
  color: white;
}
@media screen and (max-width: 600px){
  .titre{
    font-size: 18px;
  }
  .bloc1{
    width: 100%;
  }
  .bloc2{
    width: 100%;
    font-size: 18px;
  }
  .detail{
    font-size: 16px;
  }
  .button{
    height: 46.2px;
    font-size: 16px;
  }
}
@media screen and (min-width: 701px) and (max-width: 1024px){
  .titre{
    font-size: 20px;
  }
  .detail{
    font-size: 18px;
  }
  .titre1{
    font-size: 18px;
  }

  .blocc {
    padding: 30px;
  }
  .button{
    width: 70%;
    height: 55px;
  }
}
</style>
